import promise from 'es6-promise'
promise.polyfill()
import axios from 'axios'
import rum from '@/tool/rum'
import wshop from '../main.js'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL,
  //baseURL: `//${location.hostname}/admin`, // api 的 base_url
  timeout: 10000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    var token = store.state.user.token
    const encryptedAesKey = store.state.app.encryptedAesKey
    if (encryptedAesKey) {
      config.headers['Auth-Key'] = encryptedAesKey
    }

    if (!config.noToken) {
      config.headers['token'] = config.headers['token'] || token
    }
    config.headers['Request-Path'] = location.origin + location.pathname
    //console.log(config)
    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    //Promise.reject(error)
  }
)

/**
 * 下面的注释为通过在response里，自定义code来标示请求状态
 * 当code返回如下情况则说明权限有问题，登出并返回到登录页
 * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
 * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
 */
service.interceptors.response.use(
  (response) => {
    const { config } = response
    const { url, params, data } = config
    const status = response ? response.status : null
    let time = 0
    const t = new Date().getTime()
    const requestTs = (params || (data ? JSON.parse(data) : { ts: 0 }) || { ts: 0 }).ts || 0
    console.log('ts=', t, requestTs, t - requestTs, url)
    try {
      time = ((t - requestTs) / 1000).toFixed(1)
    } catch (err) {}
    // rum网络请求成功上报
    rum.report(
      url,
      {
        time,
        url,
        params: params || data,
        data: response.data ? response.data : response,
        status,
      },
      response?.data?.code === 1 ? 3 : 1
    )
    //console.log('responseresponse', response);

    if (response.data.code == 15030) {
      console.log('---------login out---')
      wshop.$toast(wshop.$t('login.nologin'))
      wshop.$root.Bus.$emit('sendmsg', {
        event: 'logout',
        noAlert: true,
      })
      return response
    } else if (response.data.code == 15053) {
      console.log('---------maintain---')
      wshop.$root.Bus.$emit('maintain', response.data.data)
      return response
    } else if (response.data.code == 101031008) {
      console.log('---------version update---')
      wshop.$root.Bus.$emit('versionUpdate')
      return response
    } else if (response.data.code == 101031014) {
      console.log('---------notfount then login out---')
      wshop.$toast(wshop.$t('account.notfound'))
      wshop.$root.Bus.$emit('sendmsg', {
        event: 'logout',
        noAlert: true,
      })
      return response
    } else if (response.data.code == 101031024) {
      console.log('---------project group error---')
      wshop.$confirm({
        content: this.$t('network.commonError'),
        hideClose: true,
        hideCancel: true,
        confirm: () => {
          window.location.reload(true)
        },
      })
      return response
    } else {
      return response
    }
  },
  (error) => {
    console.error(error)
    const { config, response } = error
    const { url, params, data } = config
    const status = response ? response.status : null
    let time = 0
    const t = new Date().getTime()
    const requestTs = (params || (data ? JSON.parse(data) : { ts: 0 }) || { ts: 0 }).ts || 0
    try {
      time = ((t - requestTs) / 1000).toFixed(1)
    } catch (err) {}
    // rum网络请求错误上报
    rum.report(
      'network_err',
      {
        time,
        url,
        params: params || data,
        status,
        data: response ? response.data : error,
      },
      2
    )
    if (error.message.indexOf('timeout') > -1) {
      console.log('error: Timeout！')
    }

    //return Promise.reject(error)
  }
)

export default service
